import { TArticleItem } from 'store/types/article'

import { ArticleCard, ArticleCardProps } from '@/screens/News/page/ui/ArticleCard/ArticleCard'

import { Col, Row } from '@/shared/ui/Grid'

import styles from './ArticlesGrid.module.scss'

export type TArticlesGrid = {
	items: ArticleCardProps[] | TArticleItem[]
	urlLocation: string
}

/** A component that renders a list of promotions mini cars
 * @param props
 * @param props.items - promotion list
 * */
export const ArticlesGrid = ({ items, urlLocation }: TArticlesGrid): JSX.Element => {
	const salesList = items.filter(({ HIDE_ON_LIST }) => !HIDE_ON_LIST)

	return (
		<section className={styles.articlesGrid}>
			<Row gutter={[42, 40]}>
				{salesList?.map(item => (
					<Col key={item.CODE} lg={6} sm={9} xs={24}>
						<ArticleCard URLPATH={urlLocation} {...item} />
					</Col>
				))}
			</Row>
		</section>
	)
}
